import { Helmet } from 'altus-ui-components';

import { APP_NAME } from 'app/app.constants';

const ProjectHelmet = ({ projectId, ...rest }) => {
  return <Helmet titleTemplate={`${projectId} - %s - ${APP_NAME}`} {...rest} />;
};

export default ProjectHelmet;
